import WaitlistForm from "@/components/forms/WaitlistForm";
import { AutoScrollCarousel } from "./AutoScrollCarousel";

const HeroSection = () => {
  return (
    <section className="section-padding bg-[#F7F5F2]">
      <div className="section-container">
        <div className="flex flex-col items-center text-center">
          <h1 className="mb-8 text-4xl font-bold tracking-tight text-[#6C4F77] md:text-5xl lg:text-6xl max-w-4xl">
            Because love lives in the details
          </h1>
          <p
            className="mb-10 max-w-4xl text-[#2C2C2C] text-lg md:text-xl leading-relaxed"
            style={{ fontFamily: "Euclid Circular A" }}
          >
            Wabisabi is an AI-powered Relationship Intelligence platform that
            helps you remember what matters — the little preferences, quiet
            moments, and check-ins that bring relationships to life.
          </p>
          <WaitlistForm variant="default" />
        </div>
      </div>
      <div className="mt-16">
        <AutoScrollCarousel />
      </div>
    </section>
  );
};

export default HeroSection;
